import { Component, Injector, Input } from "@angular/core";
import { PagedArray } from "app/shared/model/app.model";
import { GeneralParameters, TemplateProjections } from "app/shared/model/request-parameter.model";
import { QuerySelectorComponent } from "ng/src/app/shared/item-selectors/query-selector/query-selector.component";
import { QuerySelectorType } from "ng/src/app/shared/item-selectors/query-selector/query-selector.model";
import { TemplateService } from "ng/src/app/templates/shared/template.service";
import { Observable } from "rxjs";
import { Log } from '../logs/log.model';
import { Template } from './shared/template.model';

@Component(({
	selector: 'template-selector',
	templateUrl: '../shared/item-selectors/query-selector/query-selector.component.html',
	styleUrls: ['../shared/item-selectors/query-selector/query-selector.component.scss'],
	providers: [QuerySelectorComponent.ProviderAccessor(TemplateSelectorComponent)]
}))
export class TemplateSelectorComponent extends QuerySelectorComponent<Template, GeneralParameters>{
	@Input() log?: Log
	
	constructor(
		private templateService: TemplateService,
		injector: Injector
	) {
		super(injector);
	}
	
	protected constructQuery(query: string): GeneralParameters {
		const params: GeneralParameters = {
			nameLike: query,
			sort: 'name,asc'
		}
		
		if (this.log) {
			params.log = this.log.id;
		}
		
		return params;
	}
	
	protected fetch(query: GeneralParameters): Observable<PagedArray<Template>> {
		return this.templateService.fetch(query, TemplateProjections.BASE);
	}
	
	displayField: keyof Template = 'name';
	idField: keyof Template = 'id';
	readonly type: QuerySelectorType = QuerySelectorType.Single;
	
}